import * as SwitchPrimitive from "@radix-ui/react-switch";
import { clsx } from "clsx";
import React from "react";

export const ToggleButton = ({
  checked, 
  onCheckedChange, 
  disabled = false, 
  className
}) => {
    return(
        <SwitchPrimitive.Root
        checked={checked}
        disabled={disabled}
        onCheckedChange={(check)=> onCheckedChange(check)}
      className={clsx(
        "group flex items-center",
        "data-[state=checked]:bg-[#13EF00]",
        "data-[state=unchecked]:bg-[#A5A5A5]",
        "relative inline-flex h-[20px] w-[40px] flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out",
        "focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75",
        "data-[disabled]:opacity-50",
        "data-[disabled]:cursor-not-allowed",
        "data-[disabled]:bg-gray-300",
        className
      )}
    >
      <SwitchPrimitive.Thumb
        className={clsx(
          "data-[state=checked]:translate-x-5",
          "data-[state=unchecked]:translate-x-0",
          "pointer-events-none inline-block h-[14px] w-[14px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out"
        )}
      />
    </SwitchPrimitive.Root>
    )
}